var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type_stup)?_c('stup',{attrs:{"type":_vm.type_stup}}):_vm._e(),_vm._v(" "),_c('view-record',{attrs:{"token":_vm.token,"recruiter":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }